"use client";

import { Icon, type IconName } from "../../icons";
import { cn } from "../../utils/cn";

type TourTriggerButtonProps = {
  onClick: () => void;
  label: string;
  iconName?: IconName;
  /** Hide the slow pulse ring animation. */
  disablePulse?: boolean;
  className?: string;
};

export function TourTriggerButton({
  onClick,
  label,
  iconName = "tour",
  disablePulse = false,
  className,
}: TourTriggerButtonProps) {
  return (
    <>
      <button
        type="button"
        onClick={onClick}
        data-testid="tour-trigger"
        title={label}
        aria-label={label}
        className={cn(
          "relative flex size-12 items-center justify-center rounded-xl text-header-icon transition-all duration-shell ease-shell hover:bg-surface-hover hover:text-header-icon-hover",
          className,
        )}
      >
        {!disablePulse && (
          <span
            aria-hidden="true"
            className="pointer-events-none absolute inset-0 rounded-xl ring-2 ring-primary"
            style={{ animation: "tour-pulse 3.5s ease-out infinite" }}
          />
        )}
        <Icon name={iconName} size={24} />
      </button>
      <style href="tour-pulse-keyframes" precedence="default">{`
        @keyframes tour-pulse {
          0% { transform: scale(1); opacity: 0.35; }
          70% { transform: scale(1.35); opacity: 0; }
          100% { transform: scale(1.35); opacity: 0; }
        }
      `}</style>
    </>
  );
}
